import { defineComponent as _defineComponent } from 'vue'
import TagsEditor from '@/components/common/tags/TagsEditor.vue'
import { computed, ref, toRef } from 'vue'
import { useLocationQuery, useOverwriteLocationTags } from '@/api/locations'
import FormLayout from '@/components/common/FormLayout.vue'
import VsSnackbar from '@/components/vision/VsSnackbar.vue'
import { SnackType } from '@/components/vision/SnackBarType'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationTagsEditor',
  props: {
    locationId: null
  },
  emits: ['dismiss'],
  setup(__props: any, { emit }) {

const props = __props as {
  locationId: string | number | null
}


const isSnackbarVisible = ref(false)
const snackbarMessage = ref()
const snackbarType = ref(SnackType.ERROR)


const locationIdRef = toRef(props, 'locationId')
const { data: location } = useLocationQuery(locationIdRef)
const {
  mutateAsync: overwriteLocationTags,
  isLoading: isOverwritingLocationTags,
} = useOverwriteLocationTags()

const tagsEditor = ref()
const hasChanges = computed(() => tagsEditor.value?.hasChanges ?? false)
const handleSave = async () => {
  if (!locationIdRef.value) return
  await overwriteLocationTags({
    locationId: locationIdRef.value,
    tags: tagsEditor.value?.currentTags.filter((tag) => tag.isEditable) ?? [],
  })
  emit('dismiss')
}

const handleDismiss = () => {
  if (hasChanges.value) {
    const confirmation = window.confirm(
      'There are unsaved changes, are you sure you want to discard them?'
    )

    if (!confirmation) {
      return
    }
  }
  emit('dismiss')
}

const handleError = (err: any) => {
  snackbarMessage.value = err
  isSnackbarVisible.value = true
}

return { __sfc: true,props, isSnackbarVisible, snackbarMessage, snackbarType, emit, locationIdRef, location, overwriteLocationTags, isOverwritingLocationTags, tagsEditor, hasChanges, handleSave, handleDismiss, handleError, TagsEditor, FormLayout, VsSnackbar }
}

})